(() => {
  const SELECTOR_TRIGGER = '[data-open-pickup-drawer]';

  class PickupInStoreDrawer extends HTMLElement {
    constructor() {
      super();
      this.activeElement = null;
      this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.close());
      this.addEventListener('keyup', (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    open(opener) {
      if (opener) this.activeElement = opener;
      this.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      this.addEventListener(
        'transitionend',
        () => {
          const focusElement = this.querySelector('[data-drawer-close]');
          if (typeof trapFocus === 'function') {
            trapFocus(this.firstElementChild, focusElement);
          } else {
            focusElement?.focus({ preventScroll: true });
          }
        },
        { once: true },
      );
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }

    close() {
      this.classList.remove('is-visible');
      document.body.style.overflow = 'auto';
      document.removeEventListener('click', this.handleOutsideClick);
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement);
      }
    }

    handleOutsideClick = (event) => {
      const panel = this.querySelector('.cart-drawer__inner');
      if (panel && !panel.contains(event.target) && !event.target.closest(SELECTOR_TRIGGER)) {
        this.close();
      }
    };
  }

  if (!customElements.get('pickup-in-store-drawer')) {
    customElements.define('pickup-in-store-drawer', PickupInStoreDrawer);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTOR_TRIGGER);
    if (!trigger) return;
    event.preventDefault();
    const drawer = document.querySelector('pickup-in-store-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    if (drawer.classList.contains('is-visible')) return;
    drawer.open(trigger);
  });
})();
